import { css } from "lit";
import { baseStyles } from "../../theme/theme";

export const shopStyles = [
  baseStyles,
  css`
    .wrap {
      max-width: 1180px;
      margin: 0 auto;
      padding: 0.5rem 1.25rem 1.25rem;
    }
    .section {
      margin-top: 2.125rem;
    }
    .section:first-of-type {
      margin-top: 0.75rem;
    }
    .section-title {
      font-size: 1.375rem;
      font-weight: 700;
      letter-spacing: -0.01em;
      color: var(--zui-headline);
      margin: 0 0 0.35rem;
    }
    .section-subtitle {
      font-size: 0.84rem;
      color: var(--zui-details);
      margin: 0 0 1.375rem;
      line-height: 1.35;
    }
    .grid {
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 1rem;
    }
    @media (max-width: 760px) {
      .grid {
        grid-template-columns: 1fr;
        gap: 0.75rem;
      }
    }
    .card {
      display: flex;
      flex-direction: column;
      border: 1px solid var(--zui-line);
      /* X2: "square" button shape flattens the pricing cards too (0 radius);
           rounded/pill/unset keep the theme radius via the var() fallback. */
      border-radius: var(--zui-square-radius, var(--zui-radius));
      background: var(--zui-panel);
      overflow: hidden;
      animation: fadeIn 0.2s ease;
    }
    @keyframes fadeIn {
      from {
        opacity: 0;
        transform: translateY(4px);
      }
    }
    /* SHOP-42: colored banner strip across the card top ("MOST POPULAR"
         style, img-55). Banner bg = provider callout color, label = callout
         text color; top corners follow the card radius via card overflow.
         Padding-x matches .card-body so the label aligns with the name below. */
    .callout {
      padding: 0.6rem 1.375rem;
      font-size: 11px;
      font-weight: 700;
      letter-spacing: 0.12em;
      line-height: 1.35;
      text-transform: uppercase;
      background: var(--zui-callout-bg, #c77b5f);
      color: var(--zui-callout-text, #ffffff);
    }
    .callout.placeholder {
      visibility: hidden;
    }
    .card-body {
      flex: 1;
      padding: 1.25rem 1.375rem 1.5rem;
      display: flex;
      flex-direction: column;
      gap: 0.75rem;
    }
    .pname {
      font-weight: 700;
      font-size: 1.1875rem;
      letter-spacing: -0.01em;
      color: var(--zui-panel-ink);
      /* X4: names that wrap to a 2nd line (e.g. "Light Therapy Pack - 5
           Units", img-99) inherit the host page's line-height and read too
           tall. */
      line-height: 1.25;
    }
    .price {
      display: flex;
      align-items: baseline;
      gap: 0.4rem;
    }
    .price .amt {
      font-weight: 800;
      font-size: 2.25rem;
      letter-spacing: -0.02em;
      color: var(--zui-panel-ink);
      line-height: 1;
    }
    .price .cad {
      font-size: 0.78rem;
      color: var(--zui-panel-ink-soft);
    }
    /* A buyer-chosen gift amount prints a phrase, not a number — the
         display-size numeral would overflow the card at 2.25rem. */
    .price .amt.gift-any {
      font-size: 1.5rem;
    }
    .desc {
      font-size: 0.83rem;
      line-height: 1.55;
      color: var(--zui-panel-ink-soft);
      flex: 1;
    }
    .desc.spacer {
      flex: 1;
    }
    .zui-cta {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 0.4rem;
      font-weight: 700;
      letter-spacing: 0.02em;
      padding: 0.75rem 1.125rem;
      background: var(--zui-accent);
      border-radius: var(--zui-btn-radius, var(--zui-radius, 8px));
      transition: background 0.15s ease;
    }
    /* SHOP-40: hover follows the embed accent (was a fixed teal default). */
    .zui-cta:hover {
      background: var(--zui-accent-deep, var(--zui-accent));
    }
    .zui-cta svg {
      width: 16px;
      height: 16px;
    }
  `,
];
